
import { isSet, optionsToKeyValuePairs } from "../../../../../../utils/commonUtils";
import { computationRules1 } from "./DrugScreenCollection";

export const ScreeningHW = (props)=>{
    // console.log('props.lookupsOptions',props.lookupsOptions);
    const stackedFieldStyle = {
        layout: 'stacked',
        showContainerBorder: false,
        labelWrap: false,
        isLabel: false,
      };
    const charts = [{
        type:'Grid',
        col:'col-md-3',
        data:[{
            type:"PatientDetails",
            employeeDetails:props.employeeDetails,
            visitDetails:props.visitDetails
        },{
            type:"CompanyDetails",
            companyDetails:props.companyDetails
        }],
    },{
        type:'Tab',
        col:'col-md-9',
        data:[
            {
                id:'hearing_details',
                label:'Hearing Details',
                data:[
        {
            label:'Activity Details - '+props.activityName,
            fields:[
                {
                    label:'Standard: Must first perceive whispered voice at not less than 5 feet ',
                    type:'Label',
                    col:'col-12'                
                },
            {
                label:'Check if hearing aid used for test',
                col:'col-12',
                type:'RadioGroup',
                name:'check_hearing_aid_used',
                id:'check_hearing_aid_used',
                options:['Right Ear','Left Ear','Neither'],
            },
        ]
        },
         { 
            label:'Whisper Test Results',
            note:'Record distance (in feet) from driver at which a forced whispered voice can first be heard',
            fields:[
                {
                    label:'Right Ear',
                    type:'Number',
                    rangeMin:5,
                    name:'whisper_test_results_right_ear',
                    id:'whisper_test_results_right_ear',
                },
                {
                    label:'Left Ear',
                    type:'Number',
                    rangeMin:5,
                    name:'whisper_test_results_left_ear',
                    id:'whisper_test_results_left_ear',
                },
            ]
        },
        {
            label:'Notes',
            // labelStyle: "fw-semibold",
            fieldProps: stackedFieldStyle,
            fields:[
                {
                    label:'Notes',
                    col:'col-12',
                    type: "NewTextArea",
                    label: "Notes",
                    placeholder: "Add Comments",
                    className: "form-control form-control-solid",
                    name: "notes",
                    col: "col-12 border-0",
                    name:'notes',
                },
                // {
                //     label:'Suggested Result',
                //     type:'TextInput',
                //     disabled:true,
                //     options:isSet(props.lookupsOptions['chartResult'],[]),
                //     name:'suggested_status',
                // },
                {
                    type:'Blank',
                    name:'blank'
                },
                // {
                //     label:'Final Determination',
                //     type:'SelectList',
                //     options:isSet(props.lookupsOptions['chartResult'],[]),
                //     name:'status',
                // },
            
           
        ]
        },
        {
            label: 'Review / Completion',
            // labelStyle: 'fw-semibold',
            fields: [
                {
                    type: 'ProviderSignOff',
                    col: 'col-12',
                    fields: [
                        { label: 'Signature PIN', name: 'provider_pin', col: 'col-12' },
                        { label: 'Signature', type: 'NewSignature', name: 'provider_signature', col: 'col-12' },
                        { label: 'Date', type: 'Date', name: 'signed_date', col: 'col-12' },
                        // { label : "Suggested Result", disabled:true, placeholder:'Not Started',type: "TextInput", name: "suggested_status", col: "col-6"},
                        // { label : "Final Results", type: "SelectList", name: "status", col: "col-12", options:isSet(props.lookupsOptions['chartResult'],[]),statusBasedColor: true },
                        { label : "Final Results", type: "SelectList", name: "status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Pending','Normal','Abnormal','Negative','Positive','Dispensed','Administered','Failed','Passed','Non-Negative','Cancelled','Inconclusive']),statusBasedColor: true },
                        // { label : "Activity Status", type: "SelectList", name: "activity_status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Ordered','Completed','Cancelled']),statusBasedColor: true },
                        { label : "Activity Status", type: "SelectList", name: "activity_status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Pending','Pending Lab Confirmation','Pending MRO Confirmation','Ready for Review','Completed','Cancelled']),statusBasedColor: true },
                    ],
                },
            ],
        }
                ]
            },
            {
                id:'Images',
                label:'Images',
                data:[]
            }
        ]
    }];
    const defaultValue = {
        status:'Not Started',
        suggested_status:'Not Started',
        activity_status:'Not Started',
        // reason:'Pre-employment'
    };
    const headers = [{
        type: 'Tab',
        data: [
            {
                label: 'Hearing Details',
                id: 'hearing_details'
            },
            {
                label: 'Images',
                id: 'Images'
            }
        ]
    }];
    return {charts,defaultValue,headers,computationFunction: (formData,key) => ({...computationRules(formData,key), ...computationRules1(formData,key)})};
}


const computationRules = (formData,key)=>{
    let status = 'Not Started';
    let activity_status = 'Not Started';
    const horizontalRightEar = isSet(formData['whisper_test_results_right_ear'],'');
    const horizontalLeftEar = isSet(formData['whisper_test_results_left_ear'],'');
    if(horizontalRightEar==='' && horizontalLeftEar===''){
        status = 'Pending';
        activity_status = 'Pending';
    }else if(horizontalRightEar<5 &&  horizontalLeftEar<5){
        status = 'Failed';
        activity_status = 'Completed';
    }else{
        status = 'Passed';
        activity_status = 'Completed';
    }
    return (key==='status' || key==='activity_status')?{}:{'status':status,'suggested_status':status,'activity_status':activity_status};
}